<template>
  <div v-if="disabled == false && $route.name != 'InsuranceDetail' && $route.name != 'InsuranceDetailPrice' && $route.name != 'DocumentUpload' && $route.name != 'PaymentInfo' && $route.name != 'CheckPossible' && $route.name != 'DocumentUpload2' && $route.name != 'DocumentUpload3' && $route.name != 'DutyNotice' && $route.name != 'FreeTowing' && $route.name != 'FreeTowing2'"
    class="btn-bottom" @click="click">
    {{ btnTitle }}
  </div>
  <div v-else-if="disabled == true && $route.name != 'DutyNotice'" class="btn-bottom-disabled" @click="click">
    {{ btnTitle }}
  </div>
  <!-- 짙은 파란색에 안쪽 파란색 버튼 with 굵은 글씨, 옅은 글씨 -->
  <div v-else-if="disabled == false && $route.name == 'InsuranceDetail'" class="btn-bottom2" @click="click">
    <div class="inner-box">
      <span class="bold">{{ btnTitle }}</span>
      <span class="weak">{{ btnWeakTitle }}</span>
    </div>
  </div>
  <!-- 이전 and '등록/다음' two 버튼 -->
  <div v-else-if="disabled == false && $route.name == 'DocumentUpload' || $route.name == 'PaymentInfo' || $route.name == 'DocumentUpload2' || $route.name == 'DocumentUpload3' || $route.name == 'DutyNotice' || $route.name == 'CheckPossible' || $route.name == 'FreeTowing' || $route.name == 'FreeTowing2'" 
    class="btn-bottom4">
    <div class="back" @click="click2">이전</div>
    <div v-if="disabledBtnOnly == true" class="done-disabled">{{ btnTitle }}</div>
    <div v-else class="done" @click="click">{{ btnTitle }}</div>
  </div>
  <div v-else-if="disabled == true"
    class="btn-bottom4">
    <div class="back" @click="click2">이전</div>
    <div v-if="disabledBtnOnly == true" class="done-disabled">{{ btnTitle }}</div>
    <div v-else class="done" @click="click">{{ btnTitle }}</div>
  </div>
  <!-- InsuranceDetailPrice 페이지 하단부 버튼 --> 
  <!-- <div v-else-if="$route.name == 'InsuranceDetailPrice'" class="btn-double">
    <div class="left">
      <span class="bold">{{ btnTitle }}</span>
    </div>
    <div class="right">
      <span class="bold">{{ btnTitle2 }}</span>
    </div>
  </div> -->
</template>

<script>
export default {
  props: {
    btnTitle: String,
    btnTitle2: String,
    btnWeakTitle: String,
    disabled: Boolean,
    disabledBtnOnly: Boolean,
    click: Function,
    click2: Function
  }
}
</script>

<style lang="scss">
  .btn-bottom4 {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: sticky;
    width: 100%;
    height: 48px;
    left: 0px;
    bottom: 0px;
    background: #174BE6;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */

    align-items: center;
    text-align: center;
    letter-spacing: -0.32px;

    color: #FEFEFE;
    .back {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 35%;
      background: #999999;
    }
    .done {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 65%;
      height: 48px;
    }
    .done-disabled {
      cursor: not-allowed;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 65%;
      background: #666666;
    }
  }
  .btn-two-col {
    cursor: pointer;
    padding: 21px 20px 21px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: sticky;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 150px;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */

    text-align: center;
    letter-spacing: -0.32px;
    background: #0B2673;

    color: #FEFEFE;
    .inner {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 48px;
      background: #174BE6;
      b {
        font-weight: bold;
      }
    }
  }
  .btn-two-col-red {
    cursor: pointer;
    padding: 21px 20px 21px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: sticky;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 150px;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */

    text-align: center;
    letter-spacing: -0.32px;
    background: #0B2673;

    color: #FEFEFE;
    .inner {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 48px;
      background: #C94D4D;
      b {
        font-weight: bold;
      }
    }
  }
  .btn-one-col-red {
    cursor: pointer;
    padding: 21px 20px 21px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: sticky;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 90px;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */

    text-align: center;
    letter-spacing: -0.32px;
    background: #0B2673;

    color: #FEFEFE;
    .inner {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 48px;
      background: #C94D4D;
      b {
        font-weight: bold;
      }
    }
  }
  .btn-double {
    cursor: pointer;
    display: flex;
    justify-content: center;
    position: sticky;
    width: 100%;
    height: 48px;
    left: 0px;
    bottom: 0px;
    z-index: 2;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */

    align-items: center;
    text-align: center;
    letter-spacing: -0.32px;

    color: #FEFEFE;
    .left {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      background: #174BE6;
    }
    .right {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      background: #0B2673;
    }
  }
  .btn-bottom2 {
    cursor: pointer;
    display: flex;
    justify-content: center;
    position: sticky;
    width: 100%;
    height: 90px;
    left: 0px;
    bottom: 0px;
    padding: 21px 20px 21px 20px;
    background: #0B2673;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */
    letter-spacing: -0.32px;

    color: #FEFEFE;
    
    .inner-box {
      background: #174BE6;
      width: 100%;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .bold {
        font-weight: 800;
        margin-right: 4px;
      }
      .weak { 
        font-weight: 100;
      }
    }
  }
  .btn-bottom {
    cursor: pointer;
    display: flex;
    justify-content: center;
    position: sticky;
    width: 100%;
    height: 48px;
    left: 0px;
    bottom: 0px;
    background: #174BE6;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */

    align-items: center;
    text-align: center;
    letter-spacing: -0.32px;

    color: #FEFEFE;
  }
  .btn-bottom-disabled {
    cursor: not-allowed;

    display: flex;
    justify-content: center;
    position: sticky;
    width: 100%;
    height: 48px;
    left: 0px;
    bottom: 0px;
    background: #666666;;

    font-family: NanumSquareOTF;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */

    align-items: center;
    text-align: center;
    letter-spacing: -0.32px;

    color: #FEFEFE;
  }
</style>